import { toast } from 'react-toastify';
import axios from 'axios';
import API from '../../config/apiconfig';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { userLoginSuccess } from '../../action/userActions';
import { userManagementApiLoader } from '../../action/loaderActions';

export const useForgotPasswordInstance = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.user);

  const forgetPassword = ({ email }) => {
    dispatch(userManagementApiLoader({isUsermanagementLoader: true}));
    
    const data = {
      "email": email
    };

    axios.post(
        `${API.USER_MANAGEMENT_API_BASE_URL}${API.FORGOT_PASSWORD}`,
        data,
        {
            headers: {
                'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUBSCRIPTION_KEY,
            },
        }
    )
    .then((response) => {
      // Success handling
      const successMessage = response?.data?.message || 'Password reset email sent successfully!';
      toast.success(successMessage, {
        autoClose: 6000,
      });
      console.log('Forgot password success:', response.data);
      
      dispatch(userManagementApiLoader({isUsermanagementLoader: false}));
      dispatch(userLoginSuccess({...currentUser, UserEmail: email, isResetVerify: true}));
      navigate('/verify');
    })
    .catch((error) => {
      // Improved error handling
      let errorMessage = 'Failed to send password reset email. Please try again.';
      
      if (error.response) {
        // Server responded with error status
        const responseData = error.response.data;
        
        // Check for detailed errors array first
        if (responseData?.errors && Array.isArray(responseData.errors) && responseData.errors.length > 0) {
          errorMessage = responseData.errors[0]; // Use the first error message
        } else if (responseData?.message) {
          errorMessage = responseData.message;
        } else if (error.response.status === 404) {
          errorMessage = 'Email address not found. Please check and try again.';
        } else if (error.response.status === 429) {
          errorMessage = 'Too many requests. Please wait before trying again.';
        } else if (error.response.status >= 500) {
          errorMessage = 'Server error. Please try again later.';
        } else if (error.response.status === 400) {
          errorMessage = 'Invalid email address. Please check and try again.';
        }
      } else if (error.request) {
        // Network error
        errorMessage = 'Network error. Please check your connection and try again.';
      }
      
      toast.error(errorMessage, {
        autoClose: 6000,
      });
      
      console.error('Forgot password error:', error.response || error);
      dispatch(userManagementApiLoader({isUsermanagementLoader: false}));
    });
  };

  return { forgetPassword };
};